export function reformatCamelCaseString(param: string): string {
  if (!param) {
    // Must return space rather than blank string otherwise DataTable
    // will assume we are returning false and render incorrectly
    return ' ';
  }
  switch (param) {
    case 'errorInvalidSMSTemplatedid':
      return 'Error Invalid SMS Template';
    default:
      const result = param.replace(/([A-Z]+)/g, ' $1');
      const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      return finalResult;
  }
}

export const capitalize = (text) => {
  const words = text.split(' ');

  return words
    .map((word) => {
      return word?.length ? word[0].toUpperCase() + word.substring(1) : '';
    })
    .join(' ');
};

export const formatOnOffString = (value) => (value ? 'ON' : 'OFF');
